import React, { useState } from 'react'
import { Outlet } from 'react-router-dom'
import AdminSidebar from '../../components/admin/AdminSidebar'
import AdminNavbar from '../../components/admin/AdminNavbar'

const AdminLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)

  return (
    <div className="admin-layout bg-light min-vh-100">
      <AdminSidebar 
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
      />
      <AdminNavbar sidebarCollapsed={sidebarCollapsed} />
      <main 
        className="admin-main"
        style={{
          paddingTop: '70px',
          paddingLeft: sidebarCollapsed ? '70px' : '260px',
          transition: 'padding-left 0.3s ease'
        }}
      >
        <div className="p-4">
          <Outlet />
        </div>
      </main>
    </div>
  )
}

export default AdminLayout